/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useState } from "react"
import clsx from "clsx"
import { StaticImage } from "gatsby-plugin-image"

import Container from "@ecom/ui/components/Container"
import { useLocation } from "@gatsbyjs/reach-router"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"
import Timer from "../Timer/Timer"
import { PersonalForm } from "./Form/PersonalForm"
import disableWebvisor from "../../utils/disableWebvisor"
import * as styles from "./formPKW.module.scss"
import { IFormPKW } from "./types"
import { useFrame } from "../../utils/useFrame"
import { ESIALogin } from "../ESIALoginRedesign"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import useESIAFromSession from "../../hooks/useESIAFromSession"
import useLongFormFromSession from "../../hooks/useLongFormFromSession"

const defaultSubTitle = <>Быстрая&nbsp;и&nbsp;бесплатная доставка или&nbsp;самовывоз</>

export function FormPKW({
  frame = false,
  choiceOfTime = false,
  title = "Оформите карту",
  isGreenApprove = false,
  dataLayerName,
  formBtnText,
  hasBirth = false,
  hasCity = false,
  orderNum,
  longTitle = false,
  longForm = false,
  withTimer = false,
  countDownTime,
  backgroundColor,
  backgroundSection,
  productName,
  subTitle = defaultSubTitle,
  emptyForm = true,
  noGridOnMobForOffice = false,
  imgTimerType = "basic",
  variant = "standart",
  timerDescription,
  fioPlaceHolder = "ФИО",
  choiceProduct = false,
  setProductName,
  hasSelect = false,
  hasCityWithOffices = false,
  thanksPage,
  progressBar = false,
  selectItems,
  selectTitle,
  inputsColor,
  anotherTimerDescr,
  hasESIA = false,
  ESIALoginTitle,
  ESIALoginDescription,
  plaitMode,
  noVerify,
  noWomen = false,
  cityPlaceholder = "Город",
  stickerHalvaTimer,
  btnCustomColor,
  logoSovcombank = false,
  successWithShop = false,
}: IFormPKW) {
  const showESIA = useESIAFromSession(hasESIA)
  const showLongForm = useLongFormFromSession(longForm)
  const location = useLocation()
  const isDesktop = useMediaQuery("(min-width:960px)")

  const frameRef = useFrame(frame)

  // отключение записи ПД в вебвизоре
  const ref = useCallback((node: any) => {
    disableWebvisor(node)
  }, [])

  useEffect(() => {
    const handleScrollToForm = () => {
      const element = document.getElementById("app")
      if (element) {
        const offset = 120
        const position = window?.scrollY - offset
        window?.scrollTo({ top: position })
      }
    }
    if (isDesktop && location?.hash === "#app") {
      handleScrollToForm()
    }
  }, [isDesktop, location])

  const [clickOnInput, setClickOnInput] = useState(false)
  const handleClick = (e: any) => {
    if (!clickOnInput && e.target.nodeName === "INPUT") {
      pushToDataLayer({
        event: "Start_filling",
        eventLabel: globalThis?.location?.href,
      })
      setClickOnInput(true)
    }
  }

  return (
    <section
      ref={frameRef}
      style={{ background: backgroundSection }}
      className={clsx(
        styles.section,
        longTitle && styles.sectionLongTitle,
        (withTimer || noWomen) && styles.sectionWithTimer,
        backgroundColor && styles.backgroundSection,
        !emptyForm && styles.emptyForm,
        styles[variant]
      )}
      data-exclude={orderNum}
      id="formPkw"
    >
      <div className={styles.anchor} id="app" />
      <Container>
        <div
          style={{ background: backgroundColor }}
          className={clsx(
            styles.form,
            longTitle && styles.formLongTitle,
            (withTimer || noWomen) && styles.formWithTimer,
            !emptyForm && styles.emptyForm,
            noGridOnMobForOffice && styles.noGridOnMobForOffice,
            showESIA && styles.formWithEsia
          )}
        >
          {title && (
            <div className={longTitle ? styles.infoLongTitle : styles.info}>
              <h3 className={clsx(styles.head, longTitle && styles.headLongTitle)} ref={ref}>
                {title}
              </h3>
              <p className={clsx(longTitle ? styles.descrLongTitle : styles.descr)}>{subTitle}</p>
            </div>
          )}
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div
            className={styles.formContainer}
            onClick={(e) => handleClick(e)}
            onKeyDown={(e) => handleClick(e)}
          >
            <PersonalForm
              choiceOfTime={choiceOfTime}
              showESIA={showESIA}
              frame={frame}
              hasCityWithOffices={hasCityWithOffices}
              progressBar={progressBar}
              choiceProduct={choiceProduct}
              setProductName={setProductName}
              dataLayerName={dataLayerName}
              formBtnText={formBtnText}
              hasBirth={hasBirth}
              hasCity={hasCity}
              longForm={showLongForm}
              productName={productName}
              variant={variant}
              isGreenApprove={isGreenApprove}
              fioPlaceHolder={fioPlaceHolder}
              hasSelect={hasSelect}
              thanksPage={thanksPage}
              selectItems={selectItems}
              selectTitle={selectTitle}
              inputsColor={inputsColor}
              plaitMode={plaitMode}
              noVerify={noVerify}
              esiaBtn={false}
              cityPlaceholder={cityPlaceholder}
              btnCustomColor={btnCustomColor}
              logoSovcombank={logoSovcombank}
              successWithShop={successWithShop}
            />
          </div>
          {emptyForm && (
            <div className={styles.imageSticker}>
              {withTimer ? (
                <div className={styles.timer}>
                  <Timer
                    imgTimerType={imgTimerType}
                    countDownTime={countDownTime}
                    isNewYear={variant === "newYear" || variant === "newYearMedia"}
                    isPawCitty={variant === "pravdaCoffee"}
                    timerDescription={timerDescription}
                    anotherTimerDescr={anotherTimerDescr}
                    stickerHalvaTimer={stickerHalvaTimer}
                  />
                </div>
              ) : (
                !noWomen && (
                  <StaticImage
                    className={styles.img}
                    alt="women"
                    src="./images/women.png"
                    placeholder="blurred"
                    formats={["auto", "webp", "avif"]}
                  />
                )
              )}
            </div>
          )}
        </div>
      </Container>
    </section>
  )
}
